import { cva } from 'class-variance-authority'

export const avatarVariants = cva(
  `
    relative flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-surface-base-hover
    text-content-base-main select-none
  `,
  {
    variants: {
      size: {
        small: `
          size-[32px] text-10 leading-20
          [&_svg]:size-[16px]
        `,
        medium: `
          size-[40px] text-20 leading-30
          [&_svg]:size-[20px]
        `,
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  },
)
